import React from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";

const ReturnPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Full-width Section Header */}
      <div className="w-full bg-white">
        <SimpleSectionHeader title="Return" />
        <div className="flex justify-center mt-2"></div>
      </div>

      {/* Main Content Container */}
      <div className="py-10 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <p className="text-gray-700 mb-6 text-center">
            Books At Doorsteps – Return Policy
          </p>

          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Return Eligibility
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                Quality Concerns: If you receive a book that is damaged,
                defective, or not as described, you may be eligible for a
                return.
              </li>
              <li>
                Change of Mind: While we do not offer returns for change of mind
                or personal preference, we are committed to addressing any
                concerns to ensure your satisfaction.
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Return Procedure
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                Contact Us: If you believe your rented book is eligible for
                return, please contact our customer service team at [contact
                email or phone number] within [number of days] days of receiving
                the book to initiate the return process.
              </li>
              <li>
                Provide Details: Please provide details about the issue with the
                book, including photographs if applicable, to help us understand
                the nature of the problem.
              </li>
              <li>
                Return Authorization: Upon review of your request, we will
                provide you with further instructions and authorization for
                returning the book, if deemed eligible.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;
